const ErrorAlert = ({ children }) => (
    <div style={{color: 'red'}}>{children}</div>
);

export default ErrorAlert;